import { Component, EventEmitter, OnInit, Input, Output } from "@angular/core";
import { SpinnerService } from "shared-components";
import { AdminService } from '../../../services/admin.service';

@Component({
    selector: 'app-mec-pais-denominacion',
    templateUrl: './pais-denominacion.component.html'
})
export class EntidadesControlPaisDenominacionComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 5;
    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public new = false;
    public paisDenominacionEditable;

    public paisDenominacionList;

    @Input() entidadControlId;
    @Input() paises;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _adminService: AdminService
    ) { }

    ngOnInit() {
        this.getEntidadesControlPaisDenominacion();
    }

    public pageChange(page) {
        this.currentPage = page -1;
        this.getEntidadesControlPaisDenominacion();
    }

    public getEntidadesControlPaisDenominacion() {
        let filters = {
            entidadControlId: this.entidadControlId,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };
        this._spinnerService.showSpinner();
        this._adminService.getEntidadesControlPaisDenominacion(filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.totalItems = resp.paginacionMeta.totalCount;
                this.paisDenominacionList = resp.lista;
            }
        });
    }

    public newPaisDenominacion() {
        window.event.stopPropagation();
        this.new = true;
        this.paisDenominacionEditable = '';
    }

    public editableChanged(entidadControlPaisDenominacion) {
        this.paisDenominacionEditable = entidadControlPaisDenominacion;
        this.new = false;
    }

    public toRefresh(value) {
        this.getEntidadesControlPaisDenominacion();
        this.refresh.emit(value);
        this.paisDenominacionEditable = '';
        this.new = false;
    }
}
